/**
 * Preferência de idioma da interface com base no navegador.
 * Usado na tela de login (sem depender de query string).
 */
export function isBrowserLanguagePortuguese() {
  if (typeof navigator === "undefined" || !navigator.language) {
    return true;
  }
  const lang = String(navigator.language).toLowerCase();
  return lang.startsWith("pt");
}
